import React, { useCallback, useEffect, useState } from 'react';
import { Page, PageNavigation } from '@ui/components';
import { getContentManagers, IContentManager } from '@ui/api/v2/user.api';

import ContentManagerCard from './ContentManagerCard';
import { ContentManagerForm } from './ContentManagerForm';

import './ContentManagers.less';

export function ContentManagers() {
  const [managers, setManagers] = useState<IContentManager[]>([]);

  const [editContentManager, setEditContentManager] = useState<IContentManager>();

  const resetEditContentManager = useCallback(() => {
    setEditContentManager(undefined);
  }, []);

  const onDeleteContentManager = useCallback((id: number) => {
    setManagers(s => s.filter(m => m.id !== id));
  }, []);

  const fetchContentManagers = useCallback(async () => {
    const { data } = await getContentManagers();
    if (data) {
      setManagers(data);
    }
  }, []);

  const onManagerCreate = useCallback((m: IContentManager) => {
    setManagers(s => [...s, m]);
  }, []);

  const onUpdateUpdate = useCallback((cManager: IContentManager) => {
    setManagers(s =>
      s.map(m => {
        if (m.id === cManager.id) {
          return cManager;
        }
        return m;
      }),
    );
  }, []);

  useEffect(() => {
    void fetchContentManagers();
  }, [fetchContentManagers]);

  return (
    <div className="content">
      <PageNavigation title="Менеджеры" />
      <Page>
        <Page.LeftSide>
          <ContentManagerForm
            manager={editContentManager}
            onManagerCreate={onManagerCreate}
            onManagerUpdate={onUpdateUpdate}
            resetEditManager={resetEditContentManager}
          />
        </Page.LeftSide>
        <Page.Content>
          <div className="content__wrapper">
            {managers.map(m => (
              <ContentManagerCard
                key={m.id}
                manager={m}
                setEditManager={setEditContentManager}
                onDelete={onDeleteContentManager}
              />
            ))}
          </div>
        </Page.Content>
      </Page>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ContentManagers/ContentManagers.tsx